module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    attrs: {
      "id": "inspire",
      "dark": _vm.$store.getters.isDarkTheme
    }
  }, [_c('app-navigation-drawer'), _vm._v(" "), _c('v-toolbar', {
    ref: "toolbar",
    staticClass: "elevation-3",
    attrs: {
      "app": "",
      "fixed": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "disabled": _vm.$store.getters.isLoading || !!_vm.$store.getters.activeControlId == true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$store.dispatch('toggleMenu')
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('indicadores-ambientales')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('app-select-language')], 1), _vm._v(" "), _c('v-content', [_c('div', {
    ref: "mapContainer"
  }, [_c('div', {
    ref: "progress",
    staticStyle: {
      "position": "absolute",
      "z-index": "2",
      "width": "100%",
      "top": "0"
    }
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.getters.isLoading),
      expression: "$store.getters.isLoading"
    }],
    staticClass: "mb-0 mt-0",
    attrs: {
      "indeterminate": true,
      "height": "5"
    }
  })], 1), _vm._v(" "), _c('app-map', {
    ref: "appMap"
  })], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "absolute": "",
      "top": ""
    },
    model: {
      value: (_vm.hasError),
      callback: function($$v) {
        _vm.hasError = $$v
      },
      expression: "hasError"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$store.getters.errorMessage) + "\n      "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.dispatch('clearError')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cerrar')))])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 0,
      "absolute": "",
      "top": ""
    },
    model: {
      value: (_vm.hasInfo),
      callback: function($$v) {
        _vm.hasInfo = $$v
      },
      expression: "hasInfo"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$store.getters.infoMessage) + "\n    ")]), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": "",
      "inset": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("© " + _vm._s((new Date()).getFullYear()) + " GreenUrbanData")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d9c4b5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1044
// module chunks = 1